import BaseExcelService from './BaseExcelService';

class ClientExcelService extends BaseExcelService {
  getBaseUrl() {
    return '~/api/excel/client';
  }
}

export default new ClientExcelService();
